import { TrackingEvents, track } from "#webapp/src/util/analytics.util";
import { Checkbox, Switch } from "@clockwise/design-system";
import { PaywallBannerUpgradeCta } from "@clockwise/web-commons/src/ui/paywall-banner-upgrade-cta";
import { useEcosystem } from "@clockwise/web-commons/src/util/ecosystem";
import * as React from "react";
import { useMonetization } from "../../../../hooks/useMonetization";

type TeamSettingsAdminTeamCalendarProps = {
  isTeamCalendarShareChecked: boolean;
  onSharedCalendarToggle: () => void;
  isSyncWFHEventsEnabled: boolean;
  onHandleSyncWFHEventsToggle: () => void;
  teamName: string;
};

export const TeamSettingsAdminTeamCalendar = ({
  isTeamCalendarShareChecked,
  onSharedCalendarToggle,
  isSyncWFHEventsEnabled,
  onHandleSyncWFHEventsToggle,
  teamName,
}: TeamSettingsAdminTeamCalendarProps) => {
  const { canTeamAvailabilityAndNMDBeEnabled, shouldUserSeeJoinExistingPlan } = useMonetization();

  const ecosystem = useEcosystem();

  return (
    <div className="cw-mt-4 ">
      {!canTeamAvailabilityAndNMDBeEnabled && (
        <PaywallBannerUpgradeCta
          showJoinExistingPlan={shouldUserSeeJoinExistingPlan}
          bannerType="AvailabilityLocked"
          pricingTracking={() =>
            track(TrackingEvents.PAYWALLS.M2_ADMIN_AVAILABILTIY_PRICING_CLICKED)
          }
          billingTracking={() =>
            track(TrackingEvents.PAYWALLS.M2_ADMIN_AVAILABILTIY_JOIN_PLAN_CLICKED)
          }
        />
      )}
      <Switch
        checked={isTeamCalendarShareChecked && canTeamAvailabilityAndNMDBeEnabled}
        onChange={onSharedCalendarToggle}
        disabled={!canTeamAvailabilityAndNMDBeEnabled}
        label={
          <>
            <div>Create a shared “Clockwise: {teamName}" calendar and sync everyone's events</div>
            <div className="cw-body-base cw-text-slate-standard">
              When enabled, visible in everyone's calendars list in{" "}
              {ecosystem === "Google" ? "Google Calendar" : "Outlook"}.
            </div>
          </>
        }
      />
      <div className="cw-mt-1 cw-ml-14">
        <Checkbox
          checked={isSyncWFHEventsEnabled}
          disabled={!isTeamCalendarShareChecked || !canTeamAvailabilityAndNMDBeEnabled}
          onChange={onHandleSyncWFHEventsToggle}
          label="Also sync events that Clockwise categorizes as WFH (work from home)"
        />
      </div>
    </div>
  );
};
